import React from 'react'
import { Row } from 'react-bootstrap'
import { FaChartLine, FaTachometerAlt } from 'react-icons/fa'
import {
  StepCard,
  StepHeader,
  MetricsCardContainer,
  MetricsCardInner,
  MetricsCardFront,
  MetricsCardBack,
  MetricsChartContainer,
  GaugeColumn,
} from '../ModelPerformanceCard.styles'
import GaugeMetricCard from './GaugeMetricCard'
import { useGetModelQuery } from '../../../../services/modelsApi'
import AccuracyMetricsChart from '../../../views/ModelTrainingView/AccuracyMetricsChart'
import { gradients } from '../../../views/ModelGenerationView/styles'

interface ClassificationMetricsCardProps {
  modelId: string
}

const ClassificationMetricsCard: React.FC<ClassificationMetricsCardProps> = ({ modelId }) => {
  const [isMetricsFlipped, setIsMetricsFlipped] = React.useState(false)
  const { data: selectedModel } = useGetModelQuery(modelId || '', {
    skip: !modelId,
  })

  const accuracyValue = selectedModel?.metrics?.['validation:accuracy']
  const accuracy = typeof accuracyValue === 'number' ? accuracyValue : 0
  const accuracyPercentage = accuracy * 100

  return (
    <MetricsCardContainer>
      <MetricsCardInner $isFlipped={isMetricsFlipped}>
        <MetricsCardFront>
          <StepCard>
            <StepHeader $gradient={gradients.stats}>
              Model Accuracy
              <FaTachometerAlt />
              <div style={{ marginLeft: 'auto' }}>
                <button
                  onClick={() => setIsMetricsFlipped(true)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                  }}
                  aria-label="Show metrics graph"
                >
                  <FaChartLine size={16} />
                </button>
              </div>
            </StepHeader>

            <div className="metrics-step-content">
              <Row className="g-2">
                <GaugeColumn>
                  <GaugeMetricCard metricKey="Validation Accuracy" value={accuracyPercentage} />
                </GaugeColumn>
              </Row>
            </div>
          </StepCard>
        </MetricsCardFront>

        <MetricsCardBack>
          <StepCard>
            <StepHeader $gradient={gradients.stats}>
              Accuracy Over Time
              <FaChartLine />
              <div style={{ marginLeft: 'auto' }}>
                <button
                  onClick={() => setIsMetricsFlipped(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                  }}
                  aria-label="Show metrics gauges"
                >
                  <FaTachometerAlt size={16} />
                </button>
              </div>
            </StepHeader>
            <MetricsChartContainer>
              <AccuracyMetricsChart model={selectedModel} />
            </MetricsChartContainer>
          </StepCard>
        </MetricsCardBack>
      </MetricsCardInner>
    </MetricsCardContainer>
  )
}

export default ClassificationMetricsCard
